"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
var React = require("react");
var styled_components_1 = require("styled-components");
var core_1 = require("../core");
var is_1 = require("../helper/is");
var calculateCubicBezier = core_1.memo(function (values, ranges, easing) {
    var _a, _b;
    var min = ranges[0], max = ranges[1];
    var minMatch = (_a = is_1.cubicBezierRegex.exec(min)) === null || _a === void 0 ? void 0 : _a.slice(1);
    var maxMatch = (_b = is_1.cubicBezierRegex.exec(max)) === null || _b === void 0 ? void 0 : _b.slice(1);
    if (minMatch && minMatch.length === 4 && maxMatch && maxMatch.length === 4) {
        var _c = minMatch.map(function (item, index) {
            var valueKey = Object.keys(values)[index];
            return {
                name: valueKey,
                value: core_1.interpolate(values[valueKey], [parseFloat(item), parseFloat(maxMatch[index])], easing).toFixed(2)
            };
        }), x1 = _c[0], y1 = _c[1], x2 = _c[2], y2 = _c[3];
        return "cubic-bezier(" + x1.value + ", " + y1.value + ", " + x2.value + ", " + y2.value + ")";
    }
    throw new Error("Modular System Error -> \"" + min + "\" or \"" + max + "\" is not a valid cubic bezier value.");
});
exports.cubicBezier = function (value, range, easing) { return function (props) {
    var theme = props.theme;
    var values = core_1.getCubicBezierValue(value, theme);
    var ranges = core_1.getRange(range, theme);
    if (ranges.length === 1) {
        return "cubic-bezier(" + ranges[0] + ")";
    }
    return calculateCubicBezier(values, ranges, easing);
}; };
exports.useCubicBezier = function (value, range, easing) {
    var theme = React.useContext(styled_components_1.ThemeContext);
    return exports.cubicBezier(value, range, easing)({ theme: theme });
};
//# sourceMappingURL=cubicBezier.js.map